import { useCallback } from 'react'

import {
  BufferTrackerReact as BufferTracker,
  Client,
  Product,
} from '@buffer-mono/tracking-plan'

import { useCommonTrackingProperties } from '~publish/hooks/useCommonTrackingProperties'

export type PublishViewType = 'board' | 'list' | 'calendar'

export type PublishViewFilterType =
  | 'groupBy'
  | 'channel'
  | 'tag'
  | 'status'
  | 'dateRange'
  | 'postType'

export type TrackPublishViewFiltered = (properties: {
  filterType: PublishViewFilterType
  action: 'apply' | 'clear'
  filterValue?: string
  selectedCount?: number
}) => void

/**
 * Returns a function that sends `Publish View Filtered` for the given view.
 * Call it only from user actions, never on page load.
 */
export function usePublishViewFilterTracking(
  viewType: PublishViewType,
): TrackPublishViewFiltered {
  const commonTrackingProperties = useCommonTrackingProperties()

  return useCallback<TrackPublishViewFiltered>(
    ({ filterType, action, filterValue, selectedCount }) => {
      BufferTracker.publishViewFiltered({
        ...commonTrackingProperties,
        clientName: Client.PublishWeb,
        product: Product.Publish,
        viewType,
        filterType,
        action,
        filterValue: filterValue ?? null,
        selectedCount: selectedCount ?? null,
      })
    },
    [commonTrackingProperties, viewType],
  )
}
